"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RandomCapability = void 0;
var RandomCapability = /** @class */ (function () {
    function RandomCapability() {
    }
    RandomCapability.prototype.setParameter = function (name, value) {
        // Note: we don't have any configurable settings
    };
    RandomCapability.prototype.generate = function (dest) {
        window.crypto.getRandomValues(dest);
    };
    return RandomCapability;
}());
exports.RandomCapability = RandomCapability;
